import apiClient from '../utils/api';

export interface VendorApplicationData {
  businessName: string;
  contactName: string;
  email: string;
  countryCode: string;
  phone: string;
  businessType: string;
}

export interface VendorApplicationResponse {
  success: boolean;
  message: string;
  applicationId: string;
  application: {
    applicationId: string;
    businessName: string;
    contactName: string;
    email: string;
    phone: string;
    businessType: string;
    status: string;
    submittedAt: string;
  };
}

export const vendorApplicationService = {
  /**
   * Submit vendor application
   */
  submitApplication: async (
    data: VendorApplicationData
  ): Promise<VendorApplicationResponse> => {
    const response = await apiClient.post<VendorApplicationResponse>(
      '/vendors/apply',
      data
    );
    return response.data;
  },
};

